import { render, staticRenderFns } from "./EvaluationDialog.vue?vue&type=template&id=0b61a68c&scoped=true&"
import script from "./EvaluationDialog.vue?vue&type=script&lang=js&"
export * from "./EvaluationDialog.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationDialog.vue?vue&type=style&index=0&id=0b61a68c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b61a68c",
  null
  
)

export default component.exports